var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Navigation'),_c('v-main',{staticStyle:{"padding-top":"56px"}},[_c('router-view',[_c('Home')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }